/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * list of appointments availabilities of a doctor by types
 * @export
 * @interface AppointmentAvailabilities
 */
export interface AppointmentAvailabilities {
    /**
     * 
     * @type {string}
     * @memberof AppointmentAvailabilities
     */
    appointmentTypeId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentAvailabilities
     */
    slots?: Array<string>;
}

/**
 * Check if a given object implements the AppointmentAvailabilities interface.
 */
export function instanceOfAppointmentAvailabilities(value: object): value is AppointmentAvailabilities {
    return true;
}

export function AppointmentAvailabilitiesFromJSON(json: any): AppointmentAvailabilities {
    return AppointmentAvailabilitiesFromJSONTyped(json, false);
}

export function AppointmentAvailabilitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentAvailabilities {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'slots': json['slots'] == null ? undefined : json['slots'],
    };
}

export function AppointmentAvailabilitiesToJSON(json: any): AppointmentAvailabilities {
    return AppointmentAvailabilitiesToJSONTyped(json, false);
}

export function AppointmentAvailabilitiesToJSONTyped(value?: AppointmentAvailabilities | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentTypeId': value['appointmentTypeId'],
        'slots': value['slots'],
    };
}

